import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const fileInputRecipe = sva({
    slots: ['root', 'button', 'icon', 'text'],
    base: {
        root: {}, // this is the div provided by DropZone.
        button: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '1',
            width: '[fit-content]',
            boxSizing: 'border-box',
            fontFamily: 'body',
            margin: '0',
            border: '1px solid transparent',
            borderRadius: 'sm',

            // default light styles
            backgroundColor: 'white',
            color: 'elements.primary.fill',
            _dark: {
                backgroundColor: 'background.opacity-100',
                color: 'text',
                _disabled: {
                    backgroundColor: 'gray.20', // no design, so leaving bare token
                },
            },

            _hover: {
                _notDisabled: {
                    borderColor: 'elements.secondary.fill',
                },
            },
            _disabled: {
                cursor: 'not-allowed',
                backgroundColor: 'gray.20', // no design, so leaving bare token
                borderColor: 'elements.disabled.stroke',
            },
        },
        icon: {
            _groupDisabled: {
                color: 'elements.disabled.fill',
                stroke: 'elements.disabled.stroke',
            },
        },
        text: {
            _groupDisabled: {
                color: 'text.disabled',
            },
        },
    },
    // Variants
    variants: {
        iconOnly: {
            false: {},
            true: {
                button: {
                    padding: '[0]',
                    border: '[none]',
                    cursor: 'pointer',
                    backgroundColor: '[transparent]',
                    _dark: {
                        backgroundColor: '[transparent]',
                    },
                },
            },
        },
        variant: {
            contained: {}, // default
            outlined: {
                button: {
                    border: '[1px solid]',
                    borderColor: 'dark-teal.20', // ?
                    _dark: {
                        borderColor:
                            '[color-mix(in srgb, {colors.cream.100} 20%, {colors.background})]', // ?
                        color: 'text',
                    },
                },
            },
        },
        size: {
            small: {
                button: {
                    padding: '[6px 12px]',
                    fontSize: '[12px]',
                },
            },
            medium: {
                button: {
                    padding: '[12px 24px]',
                    fontSize: '[14px]',
                },
            },
            large: {
                button: {
                    padding: '[24px 36px]',
                    fontSize: '[16px]',
                },
            },
            full: {
                root: {
                    width: '[100%]',
                    height: '[100%]',
                },
                button: {
                    padding: '[12px 24px]',
                    fontSize: '[14px]',
                    width: '[100%]',
                    height: '[100%]',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outlined',
        size: 'medium',
    },
});

type FileInputRecipeProps = RecipeVariantProps<typeof fileInputRecipe>;

export { fileInputRecipe, fileInputRecipe as default };
export type { FileInputRecipeProps };
